import { Center, Text3D, RoundedBox } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import { COLORS } from "../../constants/colors";
import SurfaceButtonOpenSN from "../surfacebuttons/SurfaceButtonOpenSN.jsx";
import { BUTTON_IDS } from "../../stores/useGame";
import PointerShadow from "../pointers/PointerShadow.jsx";

const LinkendIn = ({ position = [0, 0, 0] }) => {
  const SIZE = 2.3;

  return (
    <group position={position}>
      <Center position={[0.2, 1, 0]}>
        <Text3D
          font="/fonts/helvetiker_regular.typeface.json"
          size={SIZE}
          height={0.3}
          curveSegments={12}
          bevelEnabled
          bevelThickness={0.05}
          bevelSize={0.05}
        >
          @
          <meshStandardMaterial color={"#1E90FF"} />
        </Text3D>
      </Center>
      <PointerShadow width={15} height={15} opacity={0.5} softness={0.8} />
      <RigidBody type="fixed" colliders="cuboid" ccd={false}>
        <RoundedBox args={[4, 1, 4]} radius={0.01} position-y={-0.99}>
          <meshStandardMaterial color={COLORS.surfaceElements} />
        </RoundedBox>
      </RigidBody>
      <SurfaceButtonOpenSN
        position={[0, -0.98, 5]}
        buttonId={BUTTON_IDS.EMAIL}
        width={2}
        height={1.5}
      />
    </group>
  );
};

export default LinkendIn;
